import { routesLicensing } from '@asm/components-licensing';
import { Routes } from '@angular/router';
import { RouterTools } from '@sol/components';
import { AsmLicensingAuthority } from '@asm/components-core/models/asm-licensing-authority';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';

export const routes: Routes = [
  ...RouterTools.ofApp(AsmRouteId.app_licensing, [
    ...routesLicensing,
    RouterTools.ofLazy(
      AsmRouteId.account_preferences,
      () => import('./preferences-page/preferences-page.component').then(m => m.PreferencesPageComponent),
      [AsmLicensingAuthority.VIEW],
    ),
  ]),
  RouterTools.ofLogout(AsmRouteId.account_logout),
  RouterTools.ofError(AsmRouteId.error),
  RouterTools.ofRedirect('**', AsmRouteId.error),
];
